<template>
  <DefaultPage>
    <h1 class="page-title">Support</h1>
    <div class="content">
      <section class="card">
        <h2>Kontakt</h2>
        <a href="mailto:support@movito.se" class="email">
          <BaseIconText :icon-url="svgs.ICONS.ENVELOPE">
            support@movito.se
          </BaseIconText>
        </a>
      </section>
      <section class="card">
        <h2>Visa nyheter</h2>
        <p class="muted">Öppna senaste nyheterna (release notes) i en modal.</p>
        <BaseButton
          type="button"
          :is-fullwidth="false"
          :is-rounded="true"
          :disabled="isModalVisible"
          @click="onShowNewsClick"
        >
          Visa senaste nyheterna
        </BaseButton>
      </section>
    </div>
  </DefaultPage>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import BaseIconText from '@/components/BaseIconText.vue';
import BaseButton from '@/components/BaseButton.vue';
import DefaultPage from '@/components/DefaultPage.vue';
import svgs from '@/utils/icon-constants';

export default {
  components: {
    BaseIconText,
    DefaultPage,
    BaseButton
  },

  data() {
    return {
      svgs
    };
  },
  computed: {
    ...mapState({
      RELEASE_NOTES_COOKIE_NAME: state => state.app.RELEASE_NOTES_COOKIE_NAME,
      isModalVisible: state => state.app.releaseNotesModalVisible
    })
  },
  methods: {
    ...mapMutations({
      setReleaseNotesModalVisible: 'app/setReleaseNotesModalVisible'
    }),
    onShowNewsClick() {
      localStorage.removeItem(this.RELEASE_NOTES_COOKIE_NAME);
      this.setReleaseNotesModalVisible(true);
    }
  }
};
</script>
<style scoped>
.content {
  margin-left: 4rem;
  max-width: 100%;
  width: 1200px;
  padding-bottom: 20rem;
}

.page-title {
  color: var(--color-dark-blue);
  font-size: 3.2rem;
  margin: 3.2rem 3.2rem 3.2rem 4rem;
  height: 4rem;
  padding-bottom: 2rem;
}

.card {
  max-width: 100%;
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
  font-size: 1.6rem;
  color: #2c3e50;
}

.card h2 {
  font-size: 2.8rem;
  margin: 0 0 1.5rem;
}

.email {
  color: var(--color-dark-blue);
}
.muted {
  opacity: 0.8;
  margin: 0 0 2rem;
}
</style>
